import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { LoadingModule } from '../../../../shared/ui/loading/loading.module'
import { EditDocxDialogComponent } from './edit-docx-dialog.component'

@NgModule({
    declarations: [EditDocxDialogComponent],
    exports: [EditDocxDialogComponent],
    imports: [
        CommonModule,
        LoadingModule,
    ],
})
export class EditDocxDialogModule {}
